import { nanoid } from 'nanoid'
import barba from '@barba/core';

import './Factory'
import Z from './Z';

import StickyMove from './modules/StickyMove'

// keep SPA important static elements references
let $navbar, navbarModule;

class App {
    constructor() {
        App.appId = nanoid();
        this.createSPA();
        Z.init(this);
    }

    init () {
        MODULE.init();
        $navbar = $('#navbar');
        navbarModule = MODULE.getByNameEl('NavBar', $navbar);
        StickyMove.start();
    }

    // barba enters page data.next.container is the new/entering container
    enter (data) {
        let { container } = data.next,
            $el = $(container),
            hasHeader = $el.children('header').length > 0;
        MODULE.init($el);
        StickyMove.start();
        $navbar.toggleClass('expandable', hasHeader);
        if (hasHeader) navbarModule.onAppScroll();
        $('#navbarToggle').removeClass('show');
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and
    }

    // barba leave page data.current.container is the old/leaving container
    leave (data) {
        MODULE.destroy($(data.current.container));
        StickyMove.destroy();
    }

    // Uses barba.js to create SPA
    createSPA () {
        barba.init({
            prefetchIgnore: true,
            timeout: 10000,
            transitions: [{
                leave: data => this.leave(data),
                enter: data => this.enter(data)
            }]
        });
    }
}

new App;


